import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadYaml } from '../utilis/loadYAML';
import './Home.css';
import BifurcatedPromo from '../components/BifurcatedPromo';
import {
  FaBolt,
  FaBrain,
  FaSatelliteDish,
  FaTools,
  FaFlag
} from 'react-icons/fa';

interface Section {
  id?: string;
  heading?: string;
  images?: string[];
  type: string;
  title?: string;
  description?: string;
  video?: string;
  caption?: string;
  linkText?: string;
  linkUrl?: string;
  linkHoverLine?: boolean;
  options?: {
    title: string;
    video: string;
  }[];
}

// No JSX here — just raw component references
const iconMap: Record<string, any> = {
  'Our Mission': FaBolt,
  'Engineering the Future of Autonomous Defense': FaSatelliteDish,
  'Our Business': FaTools,
  'What We Stand For': FaBrain,
  'The Road Ahead': FaFlag,
};

function Mission() {
  const [sections, setSections] = useState<Section[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadYaml('/config/mission.yaml').then((data: any) => {
      setSections(data.sections || []);
    });
  }, []);

  return (
    <div className="homepage-container">
      {sections.map((section, idx) => {
        const sectionContent = (() => {
          if (section.type === 'hero' && section.images) {
            return (
              <section
                className="career-banner"
                style={{ backgroundImage: `url(${section.images})` }}
                id={section.id || ''}
              >
                {section.title && <h1 className="career-banner-title">{section.title}</h1>}
              </section>
            );
          }

          if (section.type === 'text' && section.description) {
            const [bold, ...rest] = section.description.split('---');
            const normal = rest.join('---').trim();
            const IconComponent = iconMap[section.title || ''];

            return (
              <section className={`section text-section ${section.id || ''}`} id={section.id || ''}>
                <h2>
                  {IconComponent && (
                    <span style={{ marginRight: '8px', verticalAlign: 'middle' }}>
                      {React.createElement(IconComponent, { className: 'feature-icon-svg' })}
                    </span>
                  )}
                  {section.title}
                </h2>
                <div className="text-bifurcated-container">
                  <div className="text-bifurcated-left">
                    {bold && <p className="bold-line">{bold.trim()}</p>}
                  </div>
                  <div className="text-bifurcated-right">
                    {normal && <p className="secondary-text">{normal}</p>}
                    {section.linkText && section.linkUrl && (
                      <div
                        className={`mission-link ${section.linkHoverLine ? 'hover-line' : ''}`}
                        onClick={() => navigate(section.linkUrl!)}
                      >
                        {section.linkText}
                      </div>
                    )}
                  </div>
                </div>
              </section>
            );
          }

          if (section.type === 'bifurcatedPromo') {
            return (
              <BifurcatedPromo
                key={idx}
                id={section.id ?? ''}
                title={section.title ?? ''}
                heading={section.heading ?? ''}
                description={section.description ?? ''}
                images={section.images ?? []}
              />
            );
          }

          return null;
        })();

        return (
          <React.Fragment key={idx}>
            {sectionContent}
            {idx < sections.length - 1 && <div className="section-divider" />}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default Mission;
